import { theme } from "@tm/utility/global";
import styled from "styled-components";

import { deviceType } from "@tm/isomorphic-utils";
import { LeftIconWrapper } from "../TextButton/TextButton.style";

const defaultNudgeGradient =
  "linear-gradient(88.04deg, #c06d0c 0%, #f2c21a 100%)";

const getNudgeBackground = (colors?: string[]) => {
  if (colors && colors.length >= 2) {
    return `linear-gradient(88.04deg, ${colors[0]} 0%, ${colors[1]} 100%)`;
  }
  if (colors?.length === 1) {
    return colors[0];
  }
  return defaultNudgeGradient;
};

export const NudgeBadgeGroup = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

export const NudgeBadge = styled.span<{ $backgroundColor?: string[] }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 16px;
  background: ${(props) => getNudgeBackground(props.$backgroundColor)};
  color: ${theme.whiteText};
  font-family: Lato, sans-serif;
  font-size: 12px;
  font-weight: 900;
  line-height: 16px;
  text-transform: uppercase;
  white-space: nowrap;
`;

export const NudgeInfoTooltipWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 0;

  & > div {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    line-height: 0;
  }
`;

export const NudgeInfoIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;

  img {
    display: block;
    width: 18px;
    height: 18px;
    object-fit: contain;
  }

  &:focus-visible {
    outline: 2px solid ${theme.blueText};
    outline-offset: 2px;
    border-radius: 50%;
  }
`;

export const TravellerRowHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-width: 0;
`;

export const TravellerTitleRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
  max-width: 100%;
`;

export const TravellerRowCta = styled.div`
  flex-shrink: 0;
  margin-left: auto;

  button {
    padding: 4px;

    @media ${deviceType.mobile} {
      padding: 4px;
    }
  }

  ${LeftIconWrapper} {
    margin-right: 4px;
  }
`;

export const TravellerDetailsMissingIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;

  img {
    display: block;
    width: 16px;
    height: 16px;
    object-fit: contain;
  }
`;
